import { FormLayout, TextInput } from 'components/common'
import { FieldErrors, UseFormRegister } from 'react-hook-form'
import { getNestedErrorMessage } from 'utils/helpers/getNestedErrorMessage'
import { ERP_FIELDS } from './utils'

interface ErpSectionProps {
  title: string
  register: UseFormRegister<any>
  errors: FieldErrors<any>
  parentKey: string
  isBearerToken?: boolean
}

const ErpSection = ({
  title,
  register,
  errors,
  parentKey,
  isBearerToken = false,
}: ErpSectionProps) => {
  return (
    <>
      <h3 className="title">{title}</h3>
      <FormLayout>
        <div>
          {/* ERP End Point */}
          <TextInput
            required
            register={register}
            name={parentKey + '.' + ERP_FIELDS.URL}
            label="End Point"
            error={getNestedErrorMessage(errors, {
              key: ERP_FIELDS.URL,
              parentKey,
            })}
          />

          {!isBearerToken ? (
            <div className="mt-2 gap-10 mid-md:flex">
              {/* ERP User Name */}
              <TextInput
                required
                register={register}
                name={parentKey + '.' + ERP_FIELDS.USERNAME}
                label="Username"
                error={getNestedErrorMessage(errors, {
                  key: ERP_FIELDS.USERNAME,
                  parentKey,
                })}
              />

              {/* ERP Password */}
              <TextInput
                required
                type="password"
                register={register}
                name={parentKey + '.' + ERP_FIELDS.PASSWORD}
                label="Password"
                error={getNestedErrorMessage(errors, {
                  key: ERP_FIELDS.PASSWORD,
                  parentKey,
                })}
              />
            </div>
          ) : (
            <div>
              {/* ERP Bearer Token */}
              <TextInput
                required
                register={register}
                name={parentKey + '.' + ERP_FIELDS.BEARER_TOKEN}
                label="Bearer Token"
                error={getNestedErrorMessage(errors, {
                  key: ERP_FIELDS.BEARER_TOKEN,
                  parentKey,
                })}
              />
            </div>
          )}
        </div>
      </FormLayout>
    </>
  )
}

export default ErpSection
